import extendedFieldHooks from "ExtendedFields/selectorHooks";

import FnrConfirmCancel from "UI/FnrConfirmCancel/FnrConfirmCancel";

const ExtendedFieldsConfirmCancel = () => {
  const [isNewField] = extendedFieldHooks.useIsNewField();
  const [, setErrorMessage] = extendedFieldHooks.useErrorMessage();
  const [isLoading, submitActiveField] = extendedFieldHooks.useSubmitField();
  const clearSelection = extendedFieldHooks.useClearSelection({
    doNotNavigate: isNewField,
    modalShouldClear: isNewField,
  });

  const onCancel = () => {
    setErrorMessage(null);
    clearSelection();
  };

  return (
    <FnrConfirmCancel
      cancel={onCancel}
      confirm={submitActiveField}
      isLoading={isLoading}
    />
  );
};
export default ExtendedFieldsConfirmCancel;
